import loadable from '@loadable/component';
import {
  COMPONENT_INDEX,
  COMPONENT_NOTFOUND,
  COMPONENT_COACHINGREQUESTMANAGEMENTDETAIL,
  COMPONENT_COACHINGREQUESTMANAGEMENTLIST,
  MAINTENANCE_MODE,
} from './constants';

const importMap = {};

/* Enable Async module loading and code splitting for client */
importMap[COMPONENT_INDEX] = loadable(() => import(/* webpackChunkName: "index" */'../pages/Index'));
importMap[COMPONENT_NOTFOUND] = loadable(() => import(/* webpackChunkName: "notfound" */'../pages/NotFound'));
importMap[COMPONENT_COACHINGREQUESTMANAGEMENTDETAIL] = loadable(() => import(/* webpackChunkName: "coachManageDetail" */'../pages/CoachingRequestManagementDetail'));
importMap[COMPONENT_COACHINGREQUESTMANAGEMENTLIST] = loadable(() => import(/* webpackChunkName: "coachManageList" */'../pages/CoachingRequestManagementList'));

importMap[MAINTENANCE_MODE] = loadable(() => import(/* webpackChunkName: "maintenanceMode" */'../pages/MaintenanceMode'));

export default importMap;
